import Button from '@/components/basicComponents/button';
import Select, { ISelectValue } from '@/components/basicComponents/select';
import Header from '@/components/header';
import { GoBackButton } from '@/components/header/goBackButton';
import { PageTitle } from '@/components/header/pageTitle';
import { useResponsive } from '@/hooks/use-responsive';
import { IFieldEditor } from '@/shared/types/fieldEditor';
import { MainWrap, PaddingWrap } from '@/styles/common';
import { themeVar } from '@/styles/theme';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AiPromptSection } from './sections/aiPromptSection';
import { AiTestingSection } from './sections/aiTestingSection';

interface FieldConfigurationModalPageProps {
  allFields: IFieldEditor[];
  currentField: IFieldEditor;
  ids?: {
    funnelId?: string | null;
    funnelStaticId?: string | null;
  };
  handleCurrentFieldChange: (id: string) => void;
  openPromptEditorModalPage: () => void;
  handleClose: () => void;
}

export const FieldConfigurationModalPage = ({
  allFields,
  currentField,
  ids,
  handleCurrentFieldChange,
  openPromptEditorModalPage,
  handleClose
}: FieldConfigurationModalPageProps) => {
  const { isMobile, isTablet } = useResponsive();

  const [fieldsSelectOptions, setFieldsSelectOptions] = useState<ISelectValue[]>([]);

  useEffect(() => {
    if (!allFields?.length) return;

    const options = allFields.map((field) => ({
      value: field.id,
      label: field.name
    }));
    setFieldsSelectOptions(options);
  }, [allFields]);

  return (
    <FieldConfigurationModalPageWrapper>
      <MainWrap>
        <Header modalControl={<GoBackButton handleClose={handleClose} />} />
        <PageTitle title="Field Configuration" />
      </MainWrap>
      <MainWrap>
        <CustomPaddingWrap>
          <SelectedFieldControl>
            <SelectedFieldLabel>Select Field</SelectedFieldLabel>
            <Select
              value={currentField?.id || ''}
              setValue={handleCurrentFieldChange}
              options={fieldsSelectOptions}
              size="sm"
              width={isMobile || isTablet ? '250px' : '520px'}
            />
          </SelectedFieldControl>
          <AccordionsWrapper>
            <AiPromptSection currentField={currentField} openPromptEditorModalPage={openPromptEditorModalPage} />
            {ids?.funnelId && ids?.funnelStaticId && currentField?.promptGroup?.id && (
              <AiTestingSection currentField={currentField} funnelId={ids.funnelId} funnelStaticId={ids.funnelStaticId} />
            )}
          </AccordionsWrapper>
          <ButtonWrapper>
            <Button size="lg" onClick={handleClose}>
              Done
            </Button>
          </ButtonWrapper>
        </CustomPaddingWrap>
      </MainWrap>
    </FieldConfigurationModalPageWrapper>
  );
};

const FieldConfigurationModalPageWrapper = styled.div`
  width: 100%;
`;

const CustomPaddingWrap = styled(PaddingWrap)`
  padding-top: 20px;
`;

const SelectedFieldControl = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 0 15px;
`;

const SelectedFieldLabel = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 22.4px;
  color: ${themeVar('font.base')};
  padding: 10px 20px;
`;

const AccordionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 30px 0;
`;
